import { Routes } from '@angular/router';
import { HomePageComponent } from './features/home-page/home-page.component';
import { SettingsComponent } from './features/settings/pages/settings/settings.component';
import { SequenceDiagramPageComponent } from './features/sequence-diagram-page/page/sequence-diagram-page.component';
import { DatabaseModelPageComponent } from './features/database-model/pages/database-model-page/database-model-page/database-model-page.component';
import { DatabaseModelMenuPageComponent } from './features/database-model/pages/database-model-menu-page/database-model-menu-page/database-model-menu-page.component';
import { NotFoundComponent } from './features/not-found/not-found/not-found.component';
import { isLoggedInGuard } from './core/guards/is-logged-in.guard';
import { DisplayModelComponent } from './features/database-model/pages/display-model/display-model.component';
import { UmlPageComponent } from './features/uml/pages/uml-page/uml-page.component';
import { UserDashboardComponent } from './features/user/user-dashboard/user-dashboard.component';
import { OauthRedirectComponent } from './features/user/oauth/oauth-redirect/oauth-redirect.component';
import { ResetPasswordComponent } from './features/user/reset-password/reset-password.component';
import { PrivacyPolicyComponent } from './features/legal/privacy-policy/privacy-policy.component';
import { TermsOfServiceComponent } from './features/legal/terms-of-service/terms-of-service.component';
import { DocumentationComponent } from './features/documentation/documentation.component';

export const routes: Routes = [
  { path: '', component: HomePageComponent },
  { path: 'settings', component: SettingsComponent, canActivate: [isLoggedInGuard] },
  { path: 'sequence-diagram', component: SequenceDiagramPageComponent },
  { path: 'sequence-diagram/:id', component: SequenceDiagramPageComponent },
  { path: 'database-model/menu', component: DatabaseModelMenuPageComponent },
  { path: 'database-model/:id', component: DatabaseModelPageComponent },
  { path: 'display/model', component: DisplayModelComponent },
  { path: 'umljava', component: UmlPageComponent },
  { path: 'dashboard', component: UserDashboardComponent, canActivate: [isLoggedInGuard] },
  { path: 'oauth-redirect', component: OauthRedirectComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: 'terms-of-service', component: TermsOfServiceComponent },
  { path: 'documentation', component: DocumentationComponent },
  { path: '**', component: NotFoundComponent },
];
